import publicUrls from "../../../routes/publicUrls";

import React, { useState, useRef, useCallback, useEffect, useMemo, memo } from "react";

import { useParams, useSearchParams } from "react-router-dom";

import { Box, CircularProgress, useMediaQuery, OutlinedInput, InputAdornment, ListItemText, ListItemButton, Accordion, AccordionSummary, AccordionDetails, List, Button, Stack, Typography, IconButton, Divider, Container, SwipeableDrawer } from "@mui/material";

import { useTheme } from "@mui/material/styles";



// Icons

import SearchIcon from "@mui/icons-material/Search";

import FilterListIcon from "@mui/icons-material/FilterList";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import GridViewIcon from "@mui/icons-material/GridView";

import ViewListIcon from "@mui/icons-material/ViewList";

import BurstModeIcon from "@mui/icons-material/BurstMode";



// Local Imports

import SearchAuction from "./SearchAuction";

import NoImage from "./../../../images/Banner/no_image.jpeg";

import { categories, privatefilterArtist } from "../../../Model/Auction";

import { ArtworkCard } from "../../../components/gallery/Cards";







// Normalize HTML line breaks so <br>, <br/>, escaped <br>, and actual new lines render correctly.
const normalizeLineBreaks = (value = "") =>
  String(value)
    .replace(/&lt;\s*br\s*\/?\s*&gt;/gi, "<br />")
    .replace(/<br\s*\/?\s*>/gi, "<br />")
    .replace(/\r\n|\r|\n/g, "<br />");

// --- MODERN SIDEBAR CONTENT ---

const SidebarContent = memo(

  ({

    filteredResults,

    categoryData,

    onArtistSelect,

    onCategorySelect,

    showmore,

    setMore,

    expanded,

    setExpanded,

    expanded1,

    setExpanded1,

    onReset,

    isMobile,

    hasActiveFilter,

  }) => {

    const [artistQuery, setArtistQuery] = useState("");

    return (

      <Box

        sx={{

          width: isMobile ? 280 : "auto",

          //  p: isMobile ? 2 : 0 ,

          // Desktop vertical divider

          borderRight: !isMobile ? "1px solid #eee" : "none",

          pr: !isMobile ? 4 : 2,

          height: "100%",

        }}

      >

        <Typography

          sx={{

            display: { xs: "none", lg: "block" },

            fontWeight: 800,

            fontSize: "0.7rem",

            letterSpacing: 2,

            mb: 3,

            color: "#999",

          }}

        >

          FILTERS

        </Typography>



        <Accordion

          expanded={expanded1}

          onChange={() => setExpanded1(!expanded1)}

          elevation={0}

          sx={{ borderBottom: "1px solid #eee" }}

        >

          <AccordionSummary expandIcon={<ExpandMoreIcon />}>

            <Typography

              sx={{

                fontWeight: 700,

                fontSize: "0.8rem",

                textTransform: "uppercase",

              }}

            >

              Artists

            </Typography>

          </AccordionSummary>

          <AccordionDetails sx={{ px: 0 }}>

            <OutlinedInput

              fullWidth

              size="small"

              placeholder="Find artist..."

              value={artistQuery}

              onChange={(e) => setArtistQuery(e.target.value)}

              sx={{ mb: 1, borderRadius: 0, fontSize: "0.85rem" }}

            />

            <List sx={{ maxHeight: 300, overflow: "auto" }}>

              {filteredResults

                .filter((o) =>

                  o.artist.toLowerCase().includes(artistQuery.toLowerCase())

                )

                .slice(0, artistQuery ? 100 : showmore)

                .map((row, i) => (

                  <ListItemButton

                    key={i}

                    onClick={() => onArtistSelect(row.rowid)}

                    sx={{ py: 0.5 }}

                  >

                    <ListItemText

                      primary={row.artist}

                      primaryTypographyProps={{ fontSize: "0.85rem" }}

                    />

                    <Typography sx={{ fontSize: "0.75rem", color: "#999" }}>

                      {row.total}

                    </Typography>

                  </ListItemButton>

                ))}

            </List>

            {!artistQuery && (

              <Button

                onClick={() => setMore(showmore === 5 ? 100 : 5)}

                sx={{ color: "#000", fontSize: "0.7rem", fontWeight: 700 }}

              >

                {showmore === 5 ? "SEE ALL" : "SEE LESS"}

              </Button>

            )}

          </AccordionDetails>

        </Accordion>



        <Accordion

          expanded={expanded}

          onChange={() => setExpanded(!expanded)}

          elevation={0}

          sx={{ borderBottom: "1px solid #eee" }}

        >

          <AccordionSummary expandIcon={<ExpandMoreIcon />}>

            <Typography

              sx={{

                fontWeight: 700,

                fontSize: "0.8rem",

                textTransform: "uppercase",

              }}

            >

              Category

            </Typography>

          </AccordionSummary>

          <AccordionDetails sx={{ px: 0 }}>

            <List>

              {categoryData.map((row, i) => (

                <ListItemButton

                  key={i}

                  onClick={() => onCategorySelect(row.categories)}

                  sx={{ py: 0.5 }}

                >

                  <ListItemText

                    primary={row.categories}

                    primaryTypographyProps={{ fontSize: "0.85rem" }}

                  />

                  <Typography sx={{ fontSize: "0.75rem", color: "#999" }}>

                    {row.total}

                  </Typography>

                </ListItemButton>

              ))}

            </List>

          </AccordionDetails>

        </Accordion>



        {hasActiveFilter && (

          <Button

            fullWidth

            onClick={onReset}

            sx={{

              mt: 2,

              bgcolor: "#000",

              color: "#fff",

              fontSize: "0.7rem",

              fontWeight: 700,

              borderRadius: 0,

              py: 1.5,

            }}

          >

            RESET FILTERS

          </Button>

        )}

      </Box>

    );

  }

);



export default function Sell() {

  const theme = useTheme();

  const isDesktop = useMediaQuery("(min-width:1100px)");

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { id } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();



  const [pageNumber, setPageNumber] = useState(1);

  const [viewMode, setViewMode] = useState("grid");

  const [search, setSearch] = useState("");

  const [filter, setFilter] = useState("");

  const [openDrawer, setOpenDrawer] = useState(false);

  const [expanded, setExpanded] = useState(true);

  const [expanded1, setExpanded1] = useState(true);

  const [showmore, setMore] = useState(5);

  const [filteredResults, setFilteredResults] = useState([]);

  const [categoryData, setCategory] = useState([]);

  const [artistRowID, setArtistID] = useState("");



  const searchCat = useMemo(

    () => searchParams.get("data") || "",

    [searchParams]

  );



  const { loading, lotdata, hasMore, totalLots, errorMsg } = SearchAuction(

    pageNumber,

    id,

    search,

    searchCat,

    artistRowID

  );



  const hasActiveFilter = useMemo(

    () => search !== "" || searchCat !== "" || artistRowID !== "",

    [search, searchCat, artistRowID]

  );



  const observer = useRef();

  const lastElementRef = useCallback(

    (node) => {

      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {

        if (entries[0].isIntersecting && hasMore)

          setPageNumber((prev) => prev + 1);

      });

      if (node) observer.current.observe(node);

    },

    [loading, hasMore]

  );



  useEffect(() => {

    setPageNumber(1);

  }, [search, searchCat, artistRowID]);



  useEffect(() => {

    const loadInit = async () => {

      try {

        const [artists, cats] = await Promise.all([

          privatefilterArtist(id),

          categories(),

        ]);

        setFilteredResults(artists.data.filter((o) => o.artist !== null));

        setCategory(cats.data.filter((o) => o.categories !== null));

      } catch (e) {

        console.error(e);

      }

    };

    loadInit();

  }, [id]);



  const handleSearchSubmit = (e) => {

    e.preventDefault();

    setSearch(filter);

    setPageNumber(1);

  };

  const handleClear = () => {

    setSearch("");

    setFilter("");

    setSearchParams({});

    setArtistID("");

    setPageNumber(1);

    setOpenDrawer(false);

  };

  const handleArtistSelect = (rowid) => {

    setArtistID(rowid);

    setSearchParams({});

    setPageNumber(1);

    setSearch("");

    setOpenDrawer(false);

  };

  const handleCategorySelect = (cat) => {

    setSearchParams({ data: cat });

    setArtistID("");

    setPageNumber(1);

    setSearch("");

    setOpenDrawer(false);

  };



  const gotSinglePage = (title, auction_id, lot_group) => {



    window.location.href = publicUrls.privateSale(lot_group, auction_id, title);

  };



  const ViewSelector = () => (

    <Stack

      direction="row"

      sx={{

        border: "1px solid #eee",

        height: 45, // ✅ Pantay sa height ng OutlinedInput

        boxSizing: "border-box",

      }}

    >

      <IconButton

        size="small"

        onClick={() => setViewMode("grid")}

        sx={{

          width: 45, // Gawing square

          height: "100%", // Kuhanin ang buong height ng stack

          borderRadius: 0,

          bgcolor: viewMode === "grid" ? "#000" : "#fff",

          color: viewMode === "grid" ? "#fff" : "#000",

          "&:hover": { bgcolor: viewMode === "grid" ? "#333" : "#f5f5f5" },

          transition: "all 0.2s",

        }}

      >

        <GridViewIcon fontSize="small" />

      </IconButton>

      <IconButton

        size="small"

        onClick={() => setViewMode("list")}

        sx={{

          width: 45, // Gawing square

          height: "100%", // Kuhanin ang buong height ng stack

          borderRadius: 0,

          borderLeft: "1px solid #eee", // Boundary line sa pagitan ng dalawang buttons

          bgcolor: viewMode === "list" ? "#000" : "#fff",

          color: viewMode === "list" ? "#fff" : "#000",

          "&:hover": { bgcolor: viewMode === "list" ? "#333" : "#f5f5f5" },

          transition: "all 0.2s",

        }}

      >

        <ViewListIcon fontSize="small" />

      </IconButton>

    </Stack>

  );



  return (

    <Box sx={{ bgcolor: "#fff", minHeight: "100vh", pt: 6 }}>

      <Container maxWidth="xl">

        <Box sx={{ mb: 6, textAlign: "left" }}>

          <Typography

            variant="h2"

            sx={{

              fontFamily: "serif",

              fontWeight: 500,

              mb: 3,

              fontSize: isMobile ? "2.2rem" : "3.5rem",

              color: "#1a1a1a",

            }}

          >

            Private Sales

          </Typography>

          <Typography

            variant="body1"

            sx={{

              maxWidth: "900px",

              lineHeight: 1.8,

              color: "#333",

              fontSize: "0.95rem",

              textAlign: "justify",

            }}

          >

            Leon Gallery Private Sales provides a confidential and tailored

            platform for the acquisition and consignment of fine art, jewelry,

            furniture, rare watches, and vintage objects. Leveraging the

            Gallery’s market expertise and established global network, each

            transaction is conducted with the highest standards of

            professionalism, discretion, and integrity.

          </Typography>



          <Box sx={{ display: { xs: "none", sm: "block" }, mt: 2 }}>

            <Typography

              variant="body1"

              sx={{ color: "#666", fontSize: "0.95rem", fontStyle: "italic" }}

            >

              For inquiries, please contact our Private Sales team directly, or

              select your preferred art or collectible and submit an inquiry.

            </Typography>

          </Box>

          <Divider sx={{ mt: 5, borderColor: "#eee" }} />

        </Box>



        <Stack

          direction="column"

          spacing={2}

          sx={{ mb: 4, pb: 2, borderBottom: "1px solid #eee" }}

        >

          <Box

            sx={{

              display: "flex",

              flexDirection: isDesktop ? "row" : "column",

              justifyContent: isDesktop ? "flex-end" : "stretch",

              alignItems: "center",

              gap: 1.5,

            }}

          >

            <form

              onSubmit={handleSearchSubmit}

              style={{ width: isDesktop ? "400px" : "100%" }}

            >

              <OutlinedInput

                fullWidth

                placeholder="Search artist or artwork..."

                value={filter}

                onChange={(e) => setFilter(e.target.value)}

                sx={{

                  height: 45, // Target Height

                  borderRadius: 0,

                  bgcolor: "#f9f9f9",

                  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#eee" },

                }}

                endAdornment={

                  <InputAdornment position="end">

                    <IconButton type="submit">

                      <SearchIcon />

                    </IconButton>

                  </InputAdornment>

                }

              />

            </form>



            {isDesktop && (

              <Box sx={{ height: 45, display: "flex", alignItems: "center" }}>

                <ViewSelector />

              </Box>

            )}

          </Box>



          <Box

            sx={{

              display: "flex",

              justifyContent: "space-between",

              alignItems: "center",

            }}

          >

            <Stack direction="row" spacing={1} alignItems="center">

              {!isDesktop && (

                <Button

                  onClick={() => setOpenDrawer(true)}

                  startIcon={<FilterListIcon />}

                  sx={{

                    border: "1px solid #eee",

                    color: "#000",

                    fontWeight: 700,

                    px: 2,

                    height: 45, // Ginawang 45 para pantay sa search kung sakaling magkatabi

                    borderRadius: 0,

                  }}

                >

                  FILTER

                </Button>

              )}

              {!isDesktop && (

                <Box sx={{ height: 45, display: "flex", alignItems: "center" }}>

                  <ViewSelector />

                </Box>

              )}

            </Stack>



            {totalLots > 0 && (

              <Stack

                direction="row"

                spacing={0.5}

                alignItems="center"

                sx={{ height: 45 }}

              >

                <BurstModeIcon sx={{ fontSize: "1.1rem", color: "#999" }} />

                <Typography

                  sx={{

                    fontWeight: 700,

                    fontSize: "0.8rem",

                    color: "#666",

                    textTransform: "uppercase",

                    letterSpacing: 1,

                  }}

                >

                  {totalLots} Items

                </Typography>

              </Stack>

            )}

          </Box>

        </Stack>



        <Box

          sx={{

            display: "flex",

            flexDirection: isDesktop ? "row" : "column",

            gap: 4,

          }}

        >

          {isDesktop && (

            <Box sx={{ width: "280px", flexShrink: 0 }}>

              <SidebarContent

                filteredResults={filteredResults}

                categoryData={categoryData}

                onArtistSelect={handleArtistSelect}

                onCategorySelect={handleCategorySelect}

                showmore={showmore}

                setMore={setMore}

                expanded={expanded}

                setExpanded={setExpanded}

                expanded1={expanded1}

                setExpanded1={setExpanded1}

                onReset={handleClear}

                isMobile={false}

                hasActiveFilter={hasActiveFilter}

              />

            </Box>

          )}



          <SwipeableDrawer

            anchor="left"

            open={openDrawer}

            onClose={() => setOpenDrawer(false)}

            onOpen={() => setOpenDrawer(true)}

          >

            <SidebarContent

              filteredResults={filteredResults}

              categoryData={categoryData}

              onArtistSelect={handleArtistSelect}

              onCategorySelect={handleCategorySelect}

              showmore={showmore}

              setMore={setMore}

              expanded={expanded}

              setExpanded={setExpanded}

              expanded1={expanded1}

              setExpanded1={setExpanded1}

              onReset={handleClear}

              isMobile={true}

              hasActiveFilter={hasActiveFilter}

            />

          </SwipeableDrawer>



          <Box sx={{ flexGrow: 1 }}>



            {lotdata.length > 0 ? (

              <Box

                sx={{

                  display: "grid",

                  gridTemplateColumns:

                    viewMode === "grid"

                      ? { xs: "1fr", lg: "repeat(3, 1fr)" }

                      : "1fr",

                  gap: viewMode === "grid" ? 3 : 0.5,

                }}

              >

                {lotdata.map((item, i) => {

  const artist = item.data.artist || "";

  const title = item.data.title || "";

  const artistHtml = normalizeLineBreaks(artist);

  const titleHtml = normalizeLineBreaks(title);

  const size = normalizeLineBreaks(item.data.size || "");

  const image = item.image?.[0]?.img_url || NoImage;



  const price =

    item.data.price || item.data.asking_price

      ? `₱${Number(

          item.data.price || item.data.asking_price

        ).toLocaleString()}`

      : null;



  return (

    <Box

      key={item.data.id}

      ref={lotdata.length === i + 1 ? lastElementRef : null}

      sx={{

        minWidth: 0,

        ...(viewMode === "list"

          ? {

              borderBottom: "none",

              pb: 0,

              "&:nth-of-type(even)": {
                bgcolor: "rgba(0, 0, 0, 0.025)",
              },

            }

          : {}),

      }}

    >

      {viewMode === "grid" ? (

        /* =========================

           GRID VIEW

        ========================== */

        <ArtworkCard

          href="#private-sale"

          onClick={(event) => {

            event.preventDefault();



            gotSinglePage(

              item.data.title,

              item.data.id,

              item.data.lot_group

            );

          }}

          image={image}

          imageAlt={[artist, title]

            .filter(Boolean)

            .join(", ")}

          eyebrow={

            item.data.lot_group || "Private Sale"

          }

          artist={artist}

          title={title}

          compact

          meta={price}

          metaSize="1.05rem"

          metaWeight={600}

        />

      ) : (

        /* =========================

           LIST VIEW

        ========================== */

        <Box

          component="a"

          href="#private-sale"

          onClick={(event) => {

            event.preventDefault();



            gotSinglePage(

              item.data.title,

              item.data.id,

              item.data.lot_group

            );

          }}

          sx={{

            display: "flex",

            width: "100%",

            gap: { xs: 1.25, sm: 1.5, md: 2 },

            textDecoration: "none",

            color: "inherit",

            alignItems: "flex-start",

            cursor: "pointer",

            py: { xs: 0.75, md: 1 },
            minWidth: 0,

            "&:hover .list-image": {

              transform: "scale(1.02)",

            },

            "&:hover .list-title": {

              textDecoration: "underline",

              textUnderlineOffset: "4px",

            },

          }}

        >

          {/* IMAGE */}

          <Box

            sx={{

              width: {

                xs: 110,

                sm: 145,

                md: 180,

              },

              height: {

                xs: 135,

                sm: 175,

                md: 220,

              },

              flexShrink: 0,

              bgcolor: "#fff",

              overflow: "hidden",

              display: "flex",

              alignItems: "center",

              justifyContent: "center",

            }}

          >

            <Box

              component="img"

              className="list-image"

              src={image}

              alt={[artist, title]

                .filter(Boolean)

                .join(", ")}

              sx={{

                width: "100%",

                height: "100%",

                objectFit: "contain",

                display: "block",

                backgroundColor: "#fff",

                transition: "transform 0.25s ease",

              }}

            />

          </Box>



          {/* DETAILS */}

          <Box

            sx={{

              flex: 1,

              minWidth: 0,

              pt: 0.5,

              display: "flex",

              flexDirection: "column",

              alignItems: "flex-start",

              gap: { xs: 0.15, md: 0.25 },

            }}

          >

            {/* CATEGORY */}

            <Typography

              variant="overline"

              component="p"

              sx={{

                fontSize: { xs: "0.62rem", md: "0.7rem" },

                letterSpacing: "0.12em",

                color: "#777",

                lineHeight: 1.2,

                mb: 0,

                maxWidth: "100%",

                display: "-webkit-box",

                WebkitLineClamp: 1,

                WebkitBoxOrient: "vertical",

                overflow: "hidden",

                textOverflow: "ellipsis",

              }}

            >

              {item.data.lot_group || "Private Sale"}

            </Typography>



            {/* ARTIST */}

            <Typography

              className="list-title"

              component="h3"

              sx={{

                fontFamily: "serif",

                fontSize: {

                  xs: "1rem",

                  sm: "1.2rem",

                  md: "1.5rem",

                },

                lineHeight: { xs: 1.15, md: 1.15 },

                fontWeight: 500,

                color: "#1a1a1a",

                maxWidth: "100%",

                display: "-webkit-box",

                WebkitLineClamp: 2,

                WebkitBoxOrient: "vertical",

                overflow: "hidden",

                textOverflow: "ellipsis",

                wordBreak: "break-word",

                mb: 0,

              }}

              dangerouslySetInnerHTML={{ __html: artistHtml }}

            />



            {/* TITLE */}

            <Typography

              component="p"

              sx={{

                fontSize: {

                  xs: "0.72rem",

                  sm: "0.82rem",

                  md: "0.9rem",

                },

                lineHeight: { xs: 1.25, md: 1.3 },

                fontStyle: "italic",

                color: "#555",

                maxWidth: "100%",

                display: "-webkit-box",

                WebkitLineClamp: 2,

                WebkitBoxOrient: "vertical",

                overflow: "hidden",

                textOverflow: "ellipsis",

                wordBreak: "break-word",

                mb: 0,

              }}

              dangerouslySetInnerHTML={{ __html: titleHtml }}

            />



            {/* SIZE */}

            {size && (

              <Typography
                component="p"
                title={size.replace(/<br \/>/gi, " ")}
                sx={{
                  fontSize: { xs: "0.65rem", md: "0.78rem" },
                  lineHeight: 1.2,
                  color: "#777",
                  maxWidth: "100%",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  wordBreak: "break-word",
                  mt: 0.1,
                }}
                dangerouslySetInnerHTML={{ __html: `Size: ${size}` }}
              />
            )}

            {/* PRICE */}

            {price && (

              <Typography

                component="p"

                sx={{

                  fontSize: {

                    xs: "0.95rem",

                    sm: "1.05rem",

                  },

                  fontWeight: 600,

                  color: "#1a1a1a",

                  maxWidth: "100%",

                  mt: { xs: 0.35, md: 0.5 },

                  display: "-webkit-box",

                  WebkitLineClamp: 1,

                  WebkitBoxOrient: "vertical",

                  overflow: "hidden",

                  textOverflow: "ellipsis",

                  wordBreak: "break-word",

                }}

              >

                {price}

              </Typography>

            )}

          </Box>

        </Box>

      )}

    </Box>

  );

})}

              </Box>

            ) : (

              /* 2. NO DATA STATE */

              !loading && (

                <Box

                  sx={{

                    textAlign: "center",

                    py: 15,

                    border: "1px solid #eee",

                    bgcolor: "#fafafa",

                    mx: "auto",

                    width: "100%",

                  }}

                >

                  <Typography

                    variant="h6"

                    sx={{

                      fontFamily: '"Playfair Display", serif',

                      mb: 1,

                      textTransform: "capitalize",

                    }}

                  >

                    {errorMsg || "No records found."}

                  </Typography>

                  <Typography sx={{ color: "#666", mb: 3, fontSize: "0.9rem" }}>

                    Try adjusting your search or resetting your filters.

                  </Typography>

                  <Button

                    onClick={handleClear}

                    variant="outlined"

                    sx={{

                      color: "#000",

                      borderColor: "#000",

                      borderRadius: 0,

                      px: 4,

                      fontSize: "0.8rem",

                      letterSpacing: 1,

                      "&:hover": {

                        bgcolor: "#000",

                        color: "#fff",

                        borderColor: "#000",

                      },

                    }}

                  >

                    Reset All Filters

                  </Button>

                </Box>

              )

            )}



            {loading && (

              <Box sx={{ textAlign: "center", py: 5 }}>

                <CircularProgress color="inherit" size={30} />

              </Box>

            )}



            {!hasMore && lotdata.length > 0 && !loading && (

              <Box sx={{ textAlign: "center", py: 8 }}>

                <Typography

                  sx={{ color: "#ccc", fontSize: "0.8rem", letterSpacing: 1 }}

                >

                  END OF RESULTS

                </Typography>

              </Box>

            )}

          </Box>

        </Box>

      </Container>

    </Box>

  );

}